import { ElementType, HTMLProps, useEffect, useRef, useState } from 'react';
import { ellipsis } from 'ellipsed';
import useMediaQuery from 'src/hooks/useMediaQuery';
import { removeReservedWordsFromString } from 'src/utils/stringUtils';

export interface ITextOverflowProps extends HTMLProps<HTMLElement> {
  asComponent?: ElementType;
  children: string;
  maxLines?: number;
}

const TextOverflow = ({ asComponent: Component = 'p', children, maxLines = 1, ...props }: ITextOverflowProps) => {
  const elementTextRef = useRef<HTMLElement>(null);
  const [text, setText] = useState<string | null>(null);
  const { windowWidth } = useMediaQuery({});

  useEffect(() => {
    setText(null);
  }, [windowWidth, children, maxLines]);

  useEffect(() => {
    if (!children || !elementTextRef.current) {
      return;
    }

    if (text) {
      ellipsis(elementTextRef.current, maxLines);
      return;
    }

    setText(removeReservedWordsFromString({ text: children }));
  }, [text, maxLines, children]);

  return (
    <Component ref={elementTextRef} {...props}>
      {text}
    </Component>
  );
};

export default TextOverflow;
